import "./Profile.scss"
import React from "react"
import { useTranslation } from "react-i18next"
import { LoadPanel, SelectBox } from "devextreme-react"
import { ProfilePicture } from "../component/ProfilePicture"
import { useAuth } from "../../auth/context/authContext"
import { locale } from "devextreme/localization"
import { LocalStorageKey, localStorageService } from "../../../core/localstorage/service"
import { useScreenSize } from "../../../core/hook/useScreenSize"
import { Card, Col, Row } from "../../../core/components"

export const Profile: React.FC = () => {
    const { t, i18n } = useTranslation()
    const { user, userProfilePicture } = useAuth()
    const { isXSmall } = useScreenSize()

    const changeLanguage = (lng: string | undefined) => {
        if (lng === undefined) {
            return
        }
        i18n.changeLanguage(lng)
        locale(lng)
        localStorageService.set(LocalStorageKey.LANGUAGE, lng)
    }

    if (!user) {
        return <LoadPanel />
    }

    const languages = [
        {
            id: "en",
            label: "English"
        },
        {
            id: "nl",
            label: "Nederlands"
        }
    ]

    return (
        <Card className="profile-card p-2">

            <Row grow={0}>
                <ProfilePicture profilePicture={userProfilePicture} editable={false} />
                <Col className="mt-1">
                    <span style={{ fontWeight: 500 }}>{user.firstName} {user.lastName}</span>
                    <span style={{ fontWeight: 300, fontSize: "0.8rem" }}>{user.email}</span>
                    <span style={{ fontWeight: 300, fontSize: "0.8rem" }}>{user.administrationName}</span>
                </Col>
            </Row>

            <Row>
                <Col grow={isXSmall ? 1 : 0}>
                    <SelectBox
                        label={t("Language")}
                        stylingMode="outlined"
                        valueExpr="id"
                        displayExpr="label"
                        value={i18n.language}
                        items={languages}
                        onValueChanged={e => changeLanguage(e.value)} />
                </Col>
            </Row>

        </Card>
    )
}
